import arrow from '../assets/icon_arrow_right.svg';

/* Pill CTA — cream gradient, purple label + arrow. `small` is the compact
   auto-width variant used on the bill cards. `loading` swaps the label/arrow for
   a shimmer sweep; `hideArrow` renders the label with no trailing arrow. */
export default function Cta({ label, onClick, small = false, disabled = false, loading = false, hideArrow = false, className = '' }) {
  return (
    <button
      type="button"
      className={'bbd-cta' + (small ? ' bbd-cta-sm' : '') + (loading ? ' bbd-cta-loading' : '') + (className ? ' ' + className : '')}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
    >
      {loading ? (
        <span className="bbd-cta-shimmer" aria-hidden="true" />
      ) : (
        <>
          <span>{label}</span>
          {!hideArrow && <img src={arrow} alt="" />}
        </>
      )}
    </button>
  );
}

/* Props for a CTA described by the API (`{ text, action, params?, enabled }`);
   the action string (and its params) are handed to `onAction`, which maps
   them to a native screen. */
export function ctaProps(cta, onAction) {
  return {
    label: cta ? cta.text : '',
    disabled: !cta || cta.enabled === false,
    onClick: () => cta && onAction(cta.action, cta.params),
  };
}
